import { useQuery } from '@tanstack/react-query';
import { IActiveDay } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useGetLocationActiveDays = (
  locationCode?: string,
  locationGroupId?: string | number,
) =>
  useQuery({
    queryKey: queryKeys.locationActiveDays.all([locationGroupId, locationCode]),
    queryFn: () =>
      fetchActiveDays(
        locationCode as string,
        locationGroupId as string | number,
      ),
    enabled: !!locationCode && !!locationGroupId,
  });

export const fetchActiveDays = async (
  locationCode: string,
  locationGroupId: string | number,
): Promise<IActiveDay[]> => {
  const url = `/activeDays/${locationCode}?location_group_id=${locationGroupId}`;

  const response = await requestCCApi({ url: url });

  return response.activeDays;
};
